module.exports = __webpack_public_path__ + "files/34ed1e58e6d995f7b08b832e3d842ab8.png";